import useGoBack from '@/hooks/useGoBack';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';
import SuarteName from '@/shared-components/icons/components/public/SuarteName';
import Heading from '@/shared-components/text/components/Heading';

import AgreementContent from './AgreementContent';

import './index.css';

export default function CollaborationAuctionAgreement() {
  const goBackHandler = useGoBack("/");

  return (
    <>
      <div className="collaboration-auction-agreement__page">
        <div className="collaboration-auction-agreement__header">
          <BackArrowIcon className="collaboration-auction-agreement__back-button" onClick={goBackHandler}/>
          <SuarteName className="collaboration-auction-agreement__suartename"/>
        </div>

        <h1 className="collaboration-auction-agreement__heading">
          <Heading className="font-size-small">
            Collaboration Auction Agreement
          </Heading>
        </h1>

        <AgreementContent />
      </div>
    </>
  );
}
